import { Carousel } from 'component/Carousel/Carousel'
import { Indicators } from 'component/Carousel/co/Indicators/Indicators'
import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { Card2 } from 'page/Fullscreen/Inferences/Card2'
import { LookyQr } from 'page/InferenceScreen/LookyQr'
import { useEffect } from 'react'
import { ActionsBanner } from 'shared/inference/ActionsBanner'
import { ShareBanner2 } from 'shared/inference/ShareBanner2'
import { controller } from 'store/controller'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'
import css from './InferencesView.module.scss'

type Props = {
  carousel: CarouselStore<InferenceStore>
}

export const InferencesView = observer(({ carousel }: Props) => {
  const { many, item } = carousel
  const complete = item?.complete
  const paddingTop = opt.inline ? 40 : undefined

  useEffect(() => {
    if (complete) void controller.viewInference(item)
  }, [complete, item])

  const render = useLatestCallback((item: InferenceStore) => {
    return <Card2 carousel={carousel} inference={item} />
  })

  return <Vertical className={css.view} gap={16} pad={[16, 8]}>
    <Space spring style={{ paddingTop }}>
      <Carousel store={carousel} render={render} />
    </Space>
    {many && <Space center>
      <Indicators carousel={carousel} white />
    </Space>}

    <ActionsBanner fullscreen />
    <ShareBanner2 fullscreen />
    <LookyQr />
  </Vertical>
})
